import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetHomePageData, HttpGetHomePageDataOptions, HomePageDataResponse} from '@/features/home/http/home.http'

export const useGetHomePageData = (
    params: HttpGetHomePageDataOptions['params'],
    options?: Omit<UseQueryOptions<HomePageDataResponse>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.HOME, params],
        queryFn: () => httpGetHomePageData({params}),
        staleTime: 0,
        ...options
    })
}
